import { useI18n } from 'hooks/useI18n';
import SectionChart from '../shared/sectionChart/SectionChart';
import Switcher from '../shared/switcher/Switcher';
import { AVERAGESALARYBYROLEANDEXPERIENCETABS } from './Benefits.constants';
import { StyledSection } from './Benefits.styled';
import SalaryByEnglishLevel from './charts/SalaryByEnglishLevel';
import LocationPreference from './LocationPreference';
import SectionHeroBoxes from '../shared/sectionHeroBoxes/SectionHeroBoxes';

const Benefits: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');
  const averageSalaryByRoleAndExperienceTabs =
    AVERAGESALARYBYROLEANDEXPERIENCETABS(t);

  return (
    <StyledSection>
      <SectionHeroBoxes
        boxOne={{
          text: t('mantechcar25.benefits.hero.title'),
          color: '#08bdad'
        }}
        boxTwo={{
          text: t('mantechcar25.benefits.hero.desc'),
          color: '#3ba0b7'
        }}
        boxThree={{
          text: t('mantechcar25.benefits.hero.descExtra'),
          color: '#53e4c8'
        }}
      />
      <SectionChart
        title={t('mantechcar25.benefits.location.title')}
        desc={t('mantechcar25.benefits.location.desc')}
        descExtra={t('mantechcar25.benefits.location.text')}
        shareId="locationpreference"
        emailSubject={t('mantechcar25.share-modal.location.email-subject')}
        emailMessage={t('mantechcar25.share-modal.location.email-text')}
        shareMessage={t('mantechcar25.share-modal.location.text')}
      >
        <LocationPreference />
      </SectionChart>

      <SectionChart
        title={t('mantechcar25.benefits.average-salary-role.title')}
        desc={t('mantechcar25.benefits.average-salary-role.desc')}
        descExtra={t('mantechcar25.benefits.average-salary-role.descExtra')}
        shareId="averagesalarybyroleandexperience"
        emailSubject={t(
          'mantechcar25.share-modal.average-salary-role.email-subject'
        )}
        emailMessage={t(
          'mantechcar25.share-modal.average-salary-role.email-text'
        )}
        shareMessage={t('mantechcar25.share-modal.average-salary-role.text')}
      >
        <Switcher
          tabsName={averageSalaryByRoleAndExperienceTabs.tabsName}
          tabs={averageSalaryByRoleAndExperienceTabs.tabs}
          label={averageSalaryByRoleAndExperienceTabs.label}
        />
      </SectionChart>
      <SectionChart
        title={t('mantechcar25.benefits.english.title')}
        desc={t('mantechcar25.benefits.english.desc')}
        descExtra={t('mantechcar25.benefits.english.descExtra')}
        shareId="salarybyenglishlevel"
        emailSubject={t('mantechcar25.share-modal.english.email-subject')}
        emailMessage={t('mantechcar25.share-modal.english.email-text')}
        shareMessage={t('mantechcar25.share-modal.english.text')}
      >
        <SalaryByEnglishLevel />
      </SectionChart>
    </StyledSection>
  );
};

export default Benefits;
